import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getIP } from '../../utils/getIP';
import { getLocationFromIP } from '../../utils/getLocationFromIP';
import './index.css';
import {
  Button,
  Modal as Mod,
  ModalHeader,
  ModalBody,
  Container,
  Row,
  Col,
} from 'reactstrap';
import { Button as CustomButton } from '@components/Button';
import PulseLoader from 'react-spinners/PulseLoader';
import isEmpty from 'lodash/isEmpty';
import ExportDataModal from '../Extra/export-data-modal';
import { UnfreezeUI } from './../../assets/plugins/nucleo/js/freeze-ui';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';
import DefaultAvatar from '../../assets/img/svg/avatar.svg';
import { isNull, map } from 'lodash';
import { routesData } from './../../routes/routesData';
import { FiHelpCircle, FiUsers, FiChevronDown, FiInfo } from 'react-icons/fi';
import { BsBuildings } from 'react-icons/bs';
import { GoBellFill } from 'react-icons/go';
import { useNavbarSlotContent } from '../../contexts/NavbarSlot.context';
import firebase from '../../config/firebase.config';
import TimeTrackingButton from '../TimeTracking/TimeTrackingButton';
import TimeTrackingPopup from '../TimeTracking/TimeTrackingPopup';
import {
  requestNotificationPermission,
  sendNotification,
  TimerNotifications,
} from '../../utils/notifications';
import { timerActionTypes } from '@store/Timer/Timer.actionTypes';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { authActionTypes } from '@store/Auth/Auth.actionTypes';
import { memberActionTypes } from '@store/Member/Member.actionTypes';
import AlertListener from '../Alerts/AlertListener';
import classNames from 'classnames';
import styles from './Navbar.module.scss';
import { SvgIcon } from '../SvgIcon';
import { SvgIconSrc } from '../SvgIcon/SvgIcon.constants';
import { AddTeamModal } from '@views/Teams/components/TeamsTab/AddTeamModal.component';
import { appRoutes } from '@/routes';
import { BsListCheck } from 'react-icons/bs';
import { useSetupGuide } from '@/contexts/SetupGuide.context';
import useTrial from '@/hooks/useTrial';

const SUPPORT_PORTAL_URL =
  process.env.REACT_APP_SUPPORT_PORTAL_URL || 'https://support.prodaff.com/';
const database = firebase.firestore();
export const NavbarComponent = ({ location }) => {
  const selectedRoute = routesData.filter(
    (r) => r.path === location.pathname
  )[0];
  const { isOpen: isGuideOpen, toggle: toggleGuide } = useSetupGuide();

  const dispatch = useDispatch();
  const history = useHistory();
  const { name, avatar, email } = useSelector((state) => state.auth.profile);
  const user = useSelector((state) => ({
    userProfile: state.auth?.profile,
    activeCompany: state.auth?.profile?.activeCompany,
    companyList: state.auth?.profile?.companyList,
    activeTeamId: state.team.selectedTeamID,
    activeUserId: state.team.activeUserID,
    all: state.team.all,
  }));
  const teamReducer = useSelector((state) => ({
    loading: state.team.loading,
    activeTeam: state.team.activeTeam,
    activeUserID: state.team.activeUserID,
    members: state.team.teamMembers,
    teams: state.team.teams,
    profileID: state.auth.profile.id,
    all: state.team.all,
    timelogDayRange: state.team.timelogDayRange,
    days: state.team.days,
    start: state.team.start,
    end: state.team.end,
    selectedTeamID: state.team.selectedTeamID,
    week: state.team.week,
    topData: state.team.topData,
    active: state.team.active,
    projects: state.team.projects,
    selectedProject: state.team.selectedProject,
    membersData: state.team.membersData,
    sevenDayData: state.team.sevenDayData,
    thirtyDayData: state.team.thirtyDayData,
  }));
  const member = useSelector((state) => ({
    topProjects: state?.member?.topProjects,
    memberLoading: state?.member?.memberLoading,
    days: state?.member?.days,
    selectMember: state.member.selectMember,
    timelogDayRange: state?.member?.timelogDayRange,
    activeUserID: state?.member?.activeUserID,
    timeData: state?.member?.memberTimeData,
  }));
  const activeTeam = useMemo(() => {
    return teamReducer?.active?.Team || teamReducer?.activeTeam?.Team;
  }, [teamReducer?.active?.Team, teamReducer?.activeTeam?.Team]);
  // Unread alerts count state
  const [unreadAlertsCount, setUnreadAlertsCount] = useState(0);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);

  // Timer Redux state
  const timerReduxState = useSelector((state) => {
    return {
      isPlaying: state.timer.isPlaying,
      timer: state.timer.timer,
      timerSession: state.timer.timerSession,
      loading: state.timer.loading,
      error: state.timer.error,
      validationError: state.timer.validationError,
      successMessage: state.timer.successMessage,
      lastTimelogEntry: state.timer.lastTimelogEntry,
      punchStatus: state.timer.punchStatus,
    };
  });

  const [state, setState] = useState({
    open: '',
    selectedTitle: '',
  });
  const [rSelected, setRSelected] = useState(0);
  const [modal, setModal] = useState(false);
  const [showAddTeamModal, setShowAddTeamModal] = useState(false);
  const [inviteList, setInviteList] = useState(false);
  const [showTimeTracking, setShowTimeTracking] = useState(false);
  const timerRef = useRef(null);
  const currentTimerRef = useRef(0);

  // Pill dropdown open states
  const [isTeamOpen, setTeamOpen] = useState(false);
  const [isCompanyOpen, setCompanyOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const teamDropdownRef = useRef(null);
  const companyDropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  // Slot injected by dashboard views (date pickers, member select)
  const navbarSlot = useNavbarSlotContent();
  const [hasNotificationPermission, setHasNotificationPermission] =
    useState(false);
  const intervalNotificationRef = useRef(null);

  // Local timer state for display (reduces Redux overhead by 95%)
  const [localTimerDisplay, setLocalTimerDisplay] = useState(0);
  const reduxSyncRef = useRef(null);
  const localTimerRef = useRef(0);

  // Use Redux state for timer management
  const { isPlaying, timer, timerSession } = timerReduxState;

  /**
   * handleChange - handles team dropdown changes
   * @param {*} value
   */
  useEffect(() => {
    if (member.timelogDayRange === 0) {
      setRSelected(0);
    } else if (member.timelogDayRange === 1) {
      setRSelected(1);
    } else if (member.timelogDayRange === 7) {
      setRSelected(7);
    } else if (member.timelogDayRange === 30) {
      setRSelected(30);
    } else if (member.timelogDayRange === 'range') {
      setRSelected('range');
    }
  }, [member.timelogDayRange, member.selectMember]);

  const getUserInvite = async () => {
    try {
      await database
        .collection('membersDatabase')
        .where('accountEmailid', '==', email)
        .get()
        .then((memberData) => {
          const data = memberData.docs.map((res) => res.data());
          if (data[0]?.teamInvites?.length !== 0) {
            setInviteList(true);
            for (let i = 0; i <= data[0]?.teamInvites?.length; i++) {
              localStorage.setItem('ItemCount', data[0]?.teamInvites?.length);
            }
          }
        });
    } catch (error) {
      return error;
    }
  };

  /** teamList rows may omit activeTeamid; Firestore doc id is always the team id */
  const resolveTeamRowId = (row) => {
    if (!row || typeof row !== 'object') return '';
    const id =
      row.activeTeamid ??
      row.teamId ??
      (typeof row.id === 'string' ? row.id : '');
    return id != null && String(id).trim() !== '' ? String(id).trim() : '';
  };

  const handleChange = (value, changeInTeam) => {
    const teamDocId = resolveTeamRowId(value);
    if (!teamDocId) {
      console.warn(
        'Navbar: Cannot select team — missing team id on row',
        value
      );
      return;
    }
    const teamLabel = value?.Team ?? value?.teamName ?? '';
    let obj = { Team: teamLabel, activeTeamid: teamDocId };
    localStorage.setItem('teamData', JSON.stringify(obj));
    dispatch({
      type: teamActionTypes.SET_SELECT_TEAM_ID,
      payload: {
        selectedTeamID: teamDocId,
        activeUserID: user.userProfile?.id,
        activeTeam: {
          Team: teamLabel,
          activeTeamid: teamDocId,
          Role: value?.Role,
        },
        companyId: user?.activeCompany?.companyId,
      },
    });
    setModal(false);
    setTimeLogDays(rSelected, teamDocId, changeInTeam);
    UnfreezeUI();
    if ('inviteId' in localStorage) {
      const id = localStorage.getItem('inviteId');
      if (id !== null) {
        history.push({
          pathname: `/invites/${id}`,
          state: { access: true },
        });
      }
    }
    if (inviteList === true) {
      addNotification({
        message: 'You have pending invites that need your attention!',
        level: notificationStates.success,
      });
      setInviteList(false);
    }
  };

  const handleClick = (e) => {
    localStorage.setItem('teamData', []);
    localStorage.setItem('Team', []);
    e.preventDefault();
    dispatch({
      type: authActionTypes.LOGOUT_ACTIVE_ACCOUNT,
    });
  };

  const toggle = () => {
    setModal(!modal);
  };

  const setTimeLogDays = (days, id = undefined, changeInTeam = false) => {
    if (member.timelogDayRange === 'range' && changeInTeam === true) {
      dispatch({
        type: memberActionTypes.GET_MEMBER_TIMELOG,
        payload: {
          // days: timelogDayRange,
          days: 0,
          start: member?.start,
          end: member?.end,
          teamId: id,
          activeUserID: member.activeUserID,
          selectMember: true,
        },
      });
    } else {
      if (teamReducer.timelogDayRange === 'range' && changeInTeam === true) {
        console.log('in component of navbar range');
        setRSelected(0);
        dispatch({
          type: teamActionTypes.GET_ALL_TEAM_TIMELOG,
          payload: {
            days: 0,
            teamId: id,
            projectId: teamReducer.selectedProject,
            seven: teamReducer.sevenDayData,
            thirty: teamReducer.thirtyDayData,
          },
        });
      } else {
        dispatch({
          type: teamActionTypes.SET_TIMELOG_DAY_RANGE,
          payload: { days },
        });
        dispatch({
          type: memberActionTypes.SET_TIMELOG_DAY_RANGE,
          payload: { days },
        });
        dispatch({
          type: teamActionTypes.SET_TODAY_TIMES,
          payload: {
            selectedTeamID: id,
            day: days,
          },
        });
        dispatch({
          type: teamActionTypes.SET_TRENDS_DATA,
          payload: {
            selectedTeamID: id,
            week: teamReducer.week,
          },
        });

        if (user.all) {
          dispatch({
            type: teamActionTypes.GET_ALL_TEAM_TIMELOG,
            payload: {
              days,
              teamId: id,
              projectId: teamReducer.selectedProject,
              seven: teamReducer.sevenDayData,
              thirty: teamReducer.thirtyDayData,
            },
          });
        } else {
          dispatch({
            type: teamActionTypes.GET_MANAGER_TEAM_COLLECTION,
            payload: {
              days,
              activeTeamId: id,
              activeUserId: user.activeUserId,
            },
          });
        }
      }
    }
  };

  const setTimeLogDateRange = (days, id, start, end, userId) => {
    console.log('SET_TIMELOG_DAY_RANGE userId', days, id, start, end, userId);

    if (selectedRoute?.name === 'Teams') {
      console.log('in component of navbar team date-range');
      dispatch({
        type: teamActionTypes.GET_DATE_RANGE_DATA,
        payload: { days, start, end, id },
      });
    }
    if (selectedRoute?.name === 'User') {
      console.log('in component of navbar user date-range');
      dispatch({
        type: memberActionTypes.GET_DATE_RANGE_DATA,
        payload: {
          days,
          start,
          end,
          id,
          userId,
          selectMember: true,
        },
      });
    }
  };

  const companyTeamHandle = (compId) => {
    localStorage.setItem('teamData', []);
    dispatch({
      type: teamActionTypes.SWITCH_COMPANY_ACTIVE_TEAM,
      payload: {
        companyId: compId,
        userId: user.userProfile?.id,
      },
    });
  };

  const selectTeam = () => {
    if (
      isEmpty(teamReducer?.active) &&
      !isEmpty(user?.companyList) &&
      teamReducer.teams !== null
    ) {
      setModal(true);
    }
  };

  useEffect(() => {
    if (!isEmpty(teamReducer?.active)) {
      setTimeLogDays(rSelected, teamReducer?.active?.activeTeamid);
    }
    const rawTeamData = localStorage.getItem('teamData');
    const noTeamData =
      rawTeamData == null ||
      rawTeamData === '' ||
      rawTeamData === '[]' ||
      isEmpty(rawTeamData);
    if (noTeamData) {
      if (teamReducer?.teams?.data?.length === 1) {
        const row = teamReducer.teams.data[0];
        if (resolveTeamRowId(row)) {
          handleChange(row);
        } else {
          selectTeam();
        }
      } else if (teamReducer?.teams?.data?.length > 1) {
        selectTeam();
      }
    }
    if (!('Visited' in localStorage)) {
      getUserInvite();
    }
    if (!isEmpty(user?.activeCompany?.companyId)) {
      dispatch({
        type: teamActionTypes.GET_PROJECT,
        payload: { companyId: user?.activeCompany?.companyId },
      });
    }
  }, [user?.activeCompany?.companyId]);

  // When the saga refreshes the team list from Firestore, check whether the
  // currently stored team (localStorage teamData) is still one the user belongs
  // to. If it was deleted/removed, clear it and show the team picker.
  useEffect(() => {
    const teamsData = teamReducer?.teams?.data;
    if (!teamsData?.length) return;

    const rawTeamData = localStorage.getItem('teamData');
    const noTeamData =
      rawTeamData == null ||
      rawTeamData === '' ||
      rawTeamData === '[]' ||
      isEmpty(rawTeamData);

    if (noTeamData) return;

    try {
      const parsedTeamData = JSON.parse(rawTeamData);
      const currentTeamId = String(parsedTeamData?.activeTeamid ?? '').trim();
      if (!currentTeamId) return;

      const teamStillExists = teamsData.some(
        (team) => String(resolveTeamRowId(team)) === currentTeamId
      );

      if (!teamStillExists) {
        localStorage.removeItem('teamData');
        if (teamsData.length === 1) {
          const row = teamsData[0];
          if (resolveTeamRowId(row)) {
            handleChange(row);
          } else {
            setModal(true);
          }
        } else {
          setModal(true);
        }
      }
    } catch (_) {
      // malformed localStorage entry — ignore
    }
  }, [teamReducer.teams]);

  const formatTime = (sec) => {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${h}:${m.toString().padStart(2, '0')}:${s
      .toString()
      .padStart(2, '0')}`;
  };

  // Request notification permission when component mounts
  useEffect(() => {
    let isMounted = true;

    const checkNotificationPermission = async () => {
      try {
        const hasPermission = await requestNotificationPermission();
        if (isMounted) {
          setHasNotificationPermission(hasPermission);
        }
      } catch (error) {
        console.error('Error checking notification permission:', error);
      }
    };

    checkNotificationPermission();

    return () => {
      isMounted = false;
    };
  }, []);

  // Handle timer notifications
  const handleTimerNotification = useCallback(
    (type, duration = null) => {
      if (!hasNotificationPermission) return;

      const notification = TimerNotifications[type];
      if (!notification) return;

      const body =
        typeof notification.body === 'function'
          ? notification.body(formatTime(duration))
          : notification.body;

      sendNotification(notification.title, { body });
    },
    [hasNotificationPermission]
  );

  // Handle punch notifications
  const handlePunchNotification = useCallback(
    (type) => {
      if (!hasNotificationPermission) return;

      const notification = TimerNotifications[type];
      if (!notification) return;

      const body =
        typeof notification.body === 'function'
          ? notification.body()
          : notification.body;

      sendNotification(notification.title, { body });
    },
    [hasNotificationPermission]
  );

  // OPTIMIZED: Local timer display + periodic Redux sync (reduces memory by 90%)
  useEffect(() => {
    if (isPlaying) {
      // Local display timer - updates every second for smooth UI
      timerRef.current = setInterval(() => {
        localTimerRef.current = localTimerRef.current + 1;
        setLocalTimerDisplay(localTimerRef.current);
        currentTimerRef.current = localTimerRef.current; // Keep ref in sync for notifications
      }, 1000);

      // Periodic Redux sync - every 30 seconds for business logic/persistence
      reduxSyncRef.current = setInterval(() => {
        dispatch({
          type: timerActionTypes.UPDATE_TIMER_TIME,
          payload: { timer: localTimerRef.current },
        });
        console.log(
          '🔄 Timer synced to Redux:',
          localTimerRef.current,
          'seconds'
        );
      }, 30000); // Sync every 30 seconds
    } else {
      clearInterval(timerRef.current);
      clearInterval(reduxSyncRef.current);
    }

    return () => {
      clearInterval(timerRef.current);
      clearInterval(reduxSyncRef.current);
    };
  }, [isPlaying, dispatch]);

  // Notification logic
  useEffect(() => {
    if (isPlaying) {
      // // Set up interval notification every 3 minutes
      // intervalNotificationRef.current = setInterval(() => {
      //   handleTimerNotification('INTERVAL', currentTimerRef.current);
      // }, 180000); // 3 minutes
    } else {
      // clearInterval(intervalNotificationRef.current);
    }

    return () => {
      // clearInterval(intervalNotificationRef.current);
    };
  }, [isPlaying, handleTimerNotification]);

  const handlePlayPause = useCallback(async () => {
    if (!isPlaying) {
      // Check timer controls enabled (based on active session OR daily punch status)
      // if (!timerReduxState.punchStatus?.isPunchedIn) {
      //   // This now means: no active session AND not punched in for today
      //   const activeSessionExists = timerReduxState.punchStatus?.activeSession?.exists;
      //   const dailyPunchedIn = timerReduxState.punchStatus?.dailyPunchStatus?.isPunchedIn;

      //   let message = "Cannot start timer. ";
      //   if (!dailyPunchedIn && !activeSessionExists) {
      //     message += "Please punch in first.";
      //   } else {
      //     message += "Please ensure you are properly authenticated.";
      //   }

      //   addNotification({
      //     message,
      //     level: notificationStates.error,
      //   });
      //   return; // Exit early without starting the timer
      // }

      // Send start notification when starting timer
      handleTimerNotification('STARTED');

      console.log('🔴 Navbar handlePlayPause: Starting timer', {
        timerSession,
        teamId: teamReducer.active?.activeTeamid,
        userId: user.userProfile?.id,
        companyId: user?.activeCompany?.companyId,
      });

      // Starting timer - dispatch start action
      dispatch({
        type: timerActionTypes.START_TIMER,
        payload: {
          timerSession, // This contains project/task selection data
          teamId: teamReducer.active?.activeTeamid,
          userId: user.userProfile?.id,
          companyId: user?.activeCompany?.companyId || '',
        },
      });
    } else {
      // Validate minimum time before stopping (1 minute = 60 seconds)
      // Use local timer for real-time validation
      const currentTimerValue = localTimerRef.current;
      if (currentTimerValue < 60) {
        addNotification({
          message:
            'Timer must run for at least 1 minute before it can be saved. Please continue tracking time.',
          level: notificationStates.error,
        });
        return; // Exit early without stopping the timer
      }

      // Send stop notification BEFORE dispatching action (while timer value is still available)
      if (currentTimerValue > 0) {
        handleTimerNotification('STOPPED', currentTimerValue);
      }

      // Final sync to Redux before stopping
      dispatch({
        type: timerActionTypes.UPDATE_TIMER_TIME,
        payload: { timer: currentTimerValue },
      });

      console.log('🔴 Navbar handlePlayPause: Stopping timer', {
        currentTimer: currentTimerValue,
        reduxTimer: timer,
        timerSession,
        teamId: teamReducer.active?.activeTeamid,
        userId: user.userProfile?.id,
        companyId: user?.activeCompany?.companyId,
        timestamp: new Date().toISOString(),
      });

      // Stopping timer - dispatch stop action (removed timerSession from payload)
      dispatch({
        type: timerActionTypes.STOP_TIMER,
        payload: {
          teamId: teamReducer.active?.activeTeamid,
          userId: user.userProfile?.id,
          companyId: user?.activeCompany?.companyId || '',
        },
      });
    }
  }, [
    isPlaying,
    timerSession,
    teamReducer.active?.activeTeamid,
    user.userProfile?.id,
    user.activeCompany?.companyId,
    dispatch,
    timer,
    handleTimerNotification,
    timerReduxState.punchStatus,
  ]);

  const handleCancel = useCallback(async () => {
    // Check if there's an active session to cancel (not punch status)
    const hasActiveSession = timerReduxState.punchStatus?.activeSession?.exists;

    if (!hasActiveSession) {
      addNotification({
        message: 'No active timer session to cancel.',
        level: notificationStates.warning,
      });
      return; // Exit early without cancelling
    }

    if (timer > 0) {
      handleTimerNotification('CANCELLED');
    }

    // Clear active session using Redux action (removed timerSession from payload)
    dispatch({
      type: timerActionTypes.CANCEL_TIMER,
      payload: {
        teamId: teamReducer.active?.activeTeamid,
        userId: user.userProfile?.id,
      },
    });

    // clearInterval(intervalNotificationRef.current);
    currentTimerRef.current = 0;
  }, [
    timer,
    handleTimerNotification,
    teamReducer.active?.activeTeamid,
    user.userProfile?.id,
    dispatch,
    timerReduxState.punchStatus,
  ]);

  // Punch handlers - NEW: Uses daily punch status only (separate from timer controls)
  const handlePunchInOut = useCallback(() => {
    console.log('WebTimeTracking : PunchStatus', timerReduxState.punchStatus);

    // NEW: Use daily punch status for punch button logic (not overall isPunchedIn)
    const dailyPunchStatus = timerReduxState.punchStatus?.dailyPunchStatus;
    const isCurrentlyPunchedIn = dailyPunchStatus?.isPunchedIn || false;
    const hasActiveSession = timerReduxState.punchStatus?.activeSession?.exists;

    if (isCurrentlyPunchedIn) {
      // Punch out - check if timer is running first
      if (hasActiveSession && isPlaying) {
        addNotification({
          message: 'Please stop the timer before punching out.',
          level: notificationStates.error,
        });
        return;
      }

      console.log('WebTimeTracking : Attempting Punch Out');
      dispatch({
        type: timerActionTypes.PUNCH_OUT,
        payload: {
          teamId: teamReducer.active?.activeTeamid,
          userId: user.userProfile?.id,
          companyId: user?.activeCompany?.companyId,
        },
      });
    } else {
      // Punch in
      console.log('WebTimeTracking : Attempting Punch In');
      console.log('WebTimeTracking : Punch in data', {
        teamId: teamReducer.active?.activeTeamid,
        userId: user.userProfile?.id,
        companyId: user?.activeCompany?.companyId,
      });
      dispatch({
        type: timerActionTypes.PUNCH_IN,
        payload: {
          teamId: teamReducer.active?.activeTeamid,
          userId: user.userProfile?.id,
          companyId: user?.activeCompany?.companyId,
        },
      });
    }
  }, [
    timerReduxState.punchStatus,
    teamReducer.active?.activeTeamid,
    user.userProfile?.id,
    user?.activeCompany?.companyId,
    dispatch,
    isPlaying,
  ]);

  // Check for active timer session and punch status on component mount and team change
  useEffect(() => {
    if (teamReducer.active?.activeTeamid && user.userProfile?.id) {
      // Check punch status first
      dispatch({
        type: timerActionTypes.CHECK_PUNCH_STATUS,
        payload: {
          teamId: teamReducer.active.activeTeamid,
          userId: user.userProfile.id,
        },
      });

      // Check for active timer session
      dispatch({
        type: timerActionTypes.RESUME_TIMER,
        payload: {
          teamId: teamReducer.active.activeTeamid,
          userId: user.userProfile.id,
        },
      });
    }
  }, [teamReducer.active?.activeTeamid, user.userProfile?.id, dispatch]);

  // Handle Redux state changes
  useEffect(() => {
    if (timerReduxState.validationError) {
      // If project/task validation error, open popup
      if (
        timerReduxState.validationError.includes(
          'Please select a project and task'
        )
      ) {
        setShowTimeTracking(true);
      }
    }
  }, [timerReduxState.validationError]);

  // Handle success messages
  useEffect(() => {
    if (timerReduxState.successMessage) {
      console.log(timerReduxState.successMessage);
      // You can show success notifications here if needed
    }
  }, [timerReduxState.successMessage]);

  // Handle punch notifications
  useEffect(() => {
    if (timerReduxState.punchStatus?.successMessage) {
      if (timerReduxState.punchStatus.successMessage.includes('Punched in')) {
        handlePunchNotification('PUNCH_IN');
      } else if (
        timerReduxState.punchStatus.successMessage.includes('Punched out')
      ) {
        handlePunchNotification('PUNCH_OUT');
      }
    }
  }, [timerReduxState.punchStatus?.successMessage, handlePunchNotification]);

  // Sync local timer with Redux on timer start/resume
  useEffect(() => {
    if (isPlaying && timer > 0) {
      // When resuming, sync local state with Redux state
      localTimerRef.current = timer;
      setLocalTimerDisplay(timer);
      currentTimerRef.current = timer;
      console.log('🔄 Local timer synced with Redux on resume:', timer);
    }
  }, [isPlaying, timer]);

  // Reset local timer when stopped
  useEffect(() => {
    if (!isPlaying) {
      localTimerRef.current = 0;
      setLocalTimerDisplay(0);
      currentTimerRef.current = 0;
    }
  }, [isPlaying]);

  // Resume timer when tab is visible

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && isPlaying) {
        // Only resume if timer is currently playing
        dispatch({
          type: timerActionTypes.RESUME_TIMER,
          payload: {
            teamId: teamReducer.active?.activeTeamid,
            userId: user.userProfile?.id,
          },
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [
    isPlaying,
    teamReducer.active?.activeTeamid,
    user.userProfile?.id,
    dispatch,
  ]);

  // Comprehensive cleanup on component unmount - ADDED: Prevent memory leaks
  useEffect(() => {
    return () => {
      // Clear all timer intervals
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      if (reduxSyncRef.current) {
        clearInterval(reduxSyncRef.current);
        reduxSyncRef.current = null;
      }
      if (intervalNotificationRef.current) {
        clearInterval(intervalNotificationRef.current);
        intervalNotificationRef.current = null;
      }

      // Reset timer refs and local state
      currentTimerRef.current = 0;
      localTimerRef.current = 0;

      console.log('Navbar cleanup: All timer intervals cleared');
    };
  }, []);

  // Close pill dropdowns when clicking outside
  useEffect(() => {
    const handleOutside = (e) => {
      if (
        teamDropdownRef.current &&
        !teamDropdownRef.current.contains(e.target)
      )
        setTeamOpen(false);
      if (
        companyDropdownRef.current &&
        !companyDropdownRef.current.contains(e.target)
      )
        setCompanyOpen(false);
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(e.target)
      )
        setProfileOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  // Get userId from user profile (Redux state)
  const userId = user?.userProfile?.id || null;

  // Listen to unread alerts count
  // Alerts are stored in membersDatabase/{userId}/alerts subcollection
  useEffect(() => {
    if (!userId) {
      setUnreadAlertsCount(0);
      return;
    }
    const unsubscribe = database
      .collection('membersDatabase')
      .doc(userId)
      .collection('alerts')
      .where('isRead', '==', false)
      .onSnapshot(
        (snapshot) => {
          setUnreadAlertsCount(snapshot.size);
        },
        (error) => {
          console.error('Error listening to unread alerts count:', error);
          setUnreadAlertsCount(0);
        }
      );

    const unsubscribeNotifications = database
      .collection('membersDatabase')
      .doc(userId)
      .collection('notifications')
      .where('isRead', '==', false)
      .onSnapshot(
        (snapshot) => {
          setUnreadNotificationsCount(snapshot.size);
        },
        (error) => {
          console.error(
            'Error listening to unread notifications count:',
            error
          );
          setUnreadNotificationsCount(0);
        }
      );

    return () => {
      unsubscribe();
      unsubscribeNotifications();
    };
  }, [userId]);
  const isAdmin = user?.userProfile?.activeCompany?.role === 'Admin';
  const { isTrialActive } = useTrial();

  const handleChangeTeam = (team) => {
    let obj = { Team: team.Team, activeTeamid: team.activeTeamid };
    localStorage.setItem('teamData', JSON.stringify(obj));
    dispatch({
      type: teamActionTypes.SET_SELECT_TEAM_ID,
      payload: {
        selectedTeamID: team.activeTeamid,
        activeUserID: user.userProfile?.id,
        activeTeam: {
          Team: team.Team,
          activeTeamid: team.activeTeamid,
        },
        companyId: user?.activeCompany?.companyId,
      },
    });
    setTimeLogDays(0, team.activeTeamid);
    window.location.reload();
  };
  const getTrimmedName = (name, maxLength = 20) => {
    if (!name) return '';
    if (name.length < maxLength) return name;
    return name.substring(0, maxLength - 3) + '...';
  };

  return (
    <>
      <AlertListener userId={userId} />

      <nav className={styles.navbar} id="navbar-main">
        {/* Left: page title & subtitle from routesData */}
        <div className={styles.navLeft}>
          {selectedRoute?.name && (
            <h1 className={styles.navTitle}>{selectedRoute.name}</h1>
          )}
          {selectedRoute?.subtitle && (
            <span className={styles.navSubtitle}>
              {selectedRoute.subtitle}
              <FiInfo size={12} />
            </span>
          )}
        </div>

        {/* Right: controls */}
        <div className={styles.navRight}>
          {/* Setup guide – admin trial only */}
          {isAdmin && isTrialActive && (
            <button
              className={classNames(styles.setupGuideBtn, {
                [styles.setupGuideBtn_active]: isGuideOpen,
              })}
              onClick={toggleGuide}
              aria-label="Toggle setup guide"
            >
              <BsListCheck size={15} />
              <span>Take a tour</span>
            </button>
          )}

          {/* Slot: date pickers / member select injected by dashboard views */}
          {navbarSlot}

          {/* Team dropdown pill */}
          {teamReducer?.teams?.data?.length > 0 && (
            <div className={styles.pillWrapper} ref={teamDropdownRef}>
              <button
                className={styles.pillSelect}
                onClick={() => setTeamOpen((o) => !o)}
              >
                <FiUsers size={20} className={styles.pillSelectIcon} />
                <div className={styles.pillTextStack}>
                  <span className={styles.pillLabel}>Team</span>
                  <span className={styles.pillSelectValue}>
                    {getTrimmedName(activeTeam) || 'Select Team'}
                  </span>
                </div>
                <FiChevronDown
                  size={13}
                  className={classNames(styles.pillChevron, {
                    [styles.pillChevronOpen]: isTeamOpen,
                  })}
                />
              </button>
              {isTeamOpen && (
                <div className={styles.dropdownMenu}>
                  {map(teamReducer.teams.data, (value, index) =>
                    value.teamRemoved ? null : (
                      <button
                        key={resolveTeamRowId(value) || index}
                        className={classNames(styles.dropdownItem, {
                          [styles.dropdownItemActive]:
                            resolveTeamRowId(value) ===
                            teamReducer.selectedTeamID,
                        })}
                        onClick={() => {
                          handleChangeTeam(value);
                          setTeamOpen(false);
                        }}
                      >
                        {value.Team}
                      </button>
                    )
                  )}
                </div>
              )}
            </div>
          )}

          {/* Company dropdown pill */}
          {user?.companyList && (
            <div className={styles.pillWrapper} ref={companyDropdownRef}>
              <button
                className={styles.pillSelect}
                onClick={() => setCompanyOpen((o) => !o)}
              >
                <BsBuildings size={20} className={styles.pillSelectIcon} />
                <div className={styles.pillTextStack}>
                  <span className={styles.pillLabel}>Company</span>
                  <span className={styles.pillSelectValue}>
                    {!isEmpty(user?.activeCompany)
                      ? getTrimmedName(user.activeCompany.companyName)
                      : 'Add Company'}
                  </span>
                </div>
                <FiChevronDown
                  size={13}
                  className={classNames(styles.pillChevron, {
                    [styles.pillChevronOpen]: isCompanyOpen,
                  })}
                />
              </button>
              {isCompanyOpen && (
                <div className={styles.dropdownMenu}>
                  {!isEmpty(user.companyList) &&
                    map(user.companyList, (item) => (
                      <button
                        key={item.companyId}
                        className={classNames(styles.dropdownItem, {
                          [styles.dropdownItemActive]:
                            item.companyId === user.activeCompany?.companyId,
                        })}
                        onClick={() => {
                          companyTeamHandle(item.companyId);
                          setCompanyOpen(false);
                        }}
                      >
                        {item.companyName}
                      </button>
                    ))}
                  <div className={styles.dropdownDivider} />
                  <button
                    className={styles.dropdownItem}
                    onClick={() => {
                      history.push('/add-company');
                      setCompanyOpen(false);
                    }}
                  >
                    + Add Company
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Support button — hidden on pages that inject their own navbar controls */}
          {location.pathname !== '/dashboard-overview-new' && (
            <a
              href={SUPPORT_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.supportBtn}
            >
              <FiHelpCircle size={15} />
              <span>Support</span>
            </a>
          )}

          {/* Profile dropdown pill */}
          <div className={styles.pillWrapper} ref={profileDropdownRef}>
            <button
              className={classNames(styles.pill, styles.profilePill)}
              onClick={() => setProfileOpen((o) => !o)}
            >
              <span className={styles.pillMain}>{name}</span>
              <img
                src={!isEmpty(avatar) ? avatar : DefaultAvatar}
                className={styles.avatar}
                alt={name}
              />
              <FiChevronDown
                size={13}
                className={classNames(styles.pillChevron, {
                  [styles.pillChevronOpen]: isProfileOpen,
                })}
              />
            </button>
            {isProfileOpen && (
              <div
                className={classNames(
                  styles.dropdownMenu,
                  styles.dropdownMenuRight
                )}
              >
                <div className={styles.dropdownHeader}>Welcome!</div>
                <div className={styles.dropdownDivider} />
                <button
                  className={styles.dropdownItem}
                  onClick={() => {
                    history.push('/profile');
                    setProfileOpen(false);
                  }}
                >
                  <i className="fas fa-user" /> Profile
                </button>
                {isAdmin && (
                  <button
                    className={styles.dropdownItem}
                    onClick={() => {
                      history.push('/subscription');
                      setProfileOpen(false);
                    }}
                  >
                    <i className="ni ni-credit-card" /> Subscriptions
                  </button>
                )}
                <div className={styles.dropdownDivider} />
                <button className={styles.dropdownItem} onClick={handleClick}>
                  <i className="ni ni-user-run" /> Logout
                </button>
              </div>
            )}
          </div>

          {/* Notification bell */}
          <Link to="/notifications" className={styles.bellWrapper}>
            <GoBellFill size={18} />
            {unreadNotificationsCount > 0 && (
              <span className={styles.bellBadge}>
                {unreadNotificationsCount > 99
                  ? '99+'
                  : unreadNotificationsCount}
              </span>
            )}
          </Link>
        </div>
      </nav>
      {showTimeTracking && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            pointerEvents: 'none',
          }}
        >
          <div style={{ pointerEvents: 'auto' }}>
            <TimeTrackingPopup
              open={showTimeTracking}
              onClose={() => setShowTimeTracking(false)}
              onPlayPause={handlePlayPause}
              onCancel={handleCancel}
              onPunchInOut={handlePunchInOut}
              isPlaying={isPlaying}
              time={formatTime(localTimerDisplay)}
              projects={teamReducer.projects}
              companyId={user?.activeCompany?.companyId}
            />
          </div>
        </div>
      )}
      {/* <Modal
        isOpen={state.open === 'export-data'}
        size="sm"
        onClose={() => {
          setState({
            open: false,
            selectedTitle: '',
          });
        }}
        title={state.selectedTitle}
      >
        <div style={{ padding: '20px' }}>
          <ExportDataModal
            user={user}
            name={name}
            isTeamDashboard={
              selectedRoute?.path !== '/dashboard-team' ? false : true
            }
          />
        </div>
      </Modal> */}

      <Mod isOpen={modal} style={{ marginTop: '100px' }}>
        <ModalHeader>Choose a Team</ModalHeader>
        <ModalBody>
          <Container>
            <Row className="d-flex justify-content-center align-items-center">
              {!isEmpty(teamReducer.teams) ? (
                <>
                  {map(teamReducer.teams.data, (value, index) => {
                    if (value.teamRemoved) return null;
                    return (
                      <Col
                        md={12}
                        className="mt-1"
                        key={value?.activeTeamid || index}
                      >
                        <Button
                          className="modal-button w-100"
                          onClick={() => {
                            handleChange(value);
                          }}
                        >
                          {value.Team}
                        </Button>
                      </Col>
                    );
                  })}
                  <Col md={12} className="mt-1">
                    <CustomButton
                      className="modal-button w-100"
                      text="Add Team"
                      onClick={() => setShowAddTeamModal(true)}
                    />
                  </Col>
                </>
              ) : (
                <PulseLoader color="#4f58bb" />
              )}
            </Row>
            {/* </Input> */}
          </Container>
        </ModalBody>
      </Mod>
      <AddTeamModal
        isVisible={showAddTeamModal}
        onClose={() => {
          setShowAddTeamModal(false);
        }}
        callback={() => {
          toggle();
        }}
      />
    </>
  );
};
